import { HOST_GET_AVATAR, HOST_GET_PHOTO } from 'config';
import { PhotoPaths } from 'types/photo';

export function getImageUrl(fileName: string | null | undefined, photoPath: PhotoPaths): string {
  if (!fileName) {
    return '';
  }

  switch (photoPath) {
    case PhotoPaths.IMAGE:
      return `${HOST_GET_PHOTO}${fileName}`;
    case PhotoPaths.AVATAR:
      return `${HOST_GET_AVATAR}${fileName}`;
  }
}
